import(/* webpackMode: "eager" */ "/app_base_folder/app/prequal/page.tsx");
